import { Post } from './Post';

export type { TypePostProps } from './types';
export default Post;
